import moment from 'moment'
import dayjs from 'dayjs';

const filter = {
  //千分位格式化
  bank: function (val) {
    if (!val) return ''
    if (val.indexOf('.') < 0) {
      // 如果没有小数点后两位，加上。
      // 不能用toFixed的形式，可能会出现超出js数字范围的情况
      val += '.00'
    }
    if (val.indexOf('-') !== -1) {
      // 如果为负数，去除负号
      val = val.slice(1)
      // console.log(val);
    }
    return val.replace(/(\d)(?=(\d{3})+\.)/g, '$1,')
  },
  //剩余时分秒计算
  intervalTime: function (value) {
    var second = value,
      minute = 0,
      hour = 0,
      day = 0
    minute = parseInt(second / 60) //算出一共有多少分钟
    second %= 60 //算出有多少秒
    if (minute > 60) {
      //如果分钟大于60，计算出小时和分钟
      hour = parseInt(minute / 60)
      minute %= 60 //算出有多分钟
    }
    if (hour > 24) {
      //如果小时大于24，计算出天和小时
      day = parseInt(hour / 24)
      hour %= 24 //算出有多分钟
    }
    hour = hour < 10 ? '0' + hour : hour
    minute = minute < 10 ? '0' + minute : minute
    second = second < 10 ? '0' + second : second
    return day + '天' + hour + '小时' + minute + '分钟' + second + '秒'
  },
  dayHourTime: function (value) {
    const endTime = moment(value).unix()
    const nowTime = moment().unix()
    let second = moment(endTime).diff(moment(nowTime), 'X')
    var minute = 0,
      hour = 0,
      day = 0
    minute = parseInt(second / 60) //算出一共有多少分钟
    second %= 60 //算出有多少秒
    if (minute > 60) {
      //如果分钟大于60，计算出小时和分钟
      hour = parseInt(minute / 60)
      minute %= 60 //算出有多分钟
    }
    if (hour > 24) {
      //如果小时大于24，计算出天和小时
      day = parseInt(hour / 24)
      hour %= 24 //算出有多分钟
    }
    hour = hour < 10 ? '0' + hour : hour
    minute = minute < 10 ? '0' + minute : minute
    second = second < 10 ? '0' + second : second
    return day + '天' + hour + '小时'
  },
  //挂号订单状态筛选
  reserveStatus: function (val) {
    let data = Number(val)
    switch (data) {
      case 0:
        return '待缴费'
      case 1:
        return '已付款'
      case 2:
        return '已退款'
      case 3:
        return '已取消'
      case 4:
        return '退款中'
      case 5:
        return '已过期'
      case 6:
        return '退款失败'
      case 10:
        return '已完成'
      default:
        return ''
    }
  },
  //支付方式筛选
  payMethod: function (val) {
    let data = Number(val)
    switch (data) {
      case 1:
        return '微信'
      case 2:
        return '支付宝'
      case 3:
        return '银联'
      default:
        return ''
    }
  },
  //身份证星号转换
  idCardShield: function (val) {
    return val.replace(/(.{3}).*(.{4})/, '$1**********$2')
  },
  // 评论时间转换
  replyTime: function (val) {
    let time = (dayjs() - dayjs(val)) / 1000
    switch (true) {
      case time < 60:
        return time.toFixed(0) + '秒前'
      case time >= 60 && time < (60 * 60):
        return Math.floor(time / 60) + '分钟前'
      case time >= (60 * 60) && time < (60 * 60 * 24):
        return Math.floor(time / (60 * 60)) + '小时前'
      case time >= (60 * 60 * 24) && time < (60 * 60 * 24 * 3):
        return Math.floor(time / (60 * 60 * 24)) + '天前'
      default:
        return val
    }
  },
  // 处理时间
  calcTime(val) {
    if (val) return val.substring(0, val.indexOf(" "));
    return "";
  },
}
export default filter
